document.addEventListener('DOMContentLoaded', function () {
	// Select all video wrappers added by the block (no Liquid in asset)
	const videos = document.querySelectorAll('.media-with-text-block__video-wrapper');

	if (!videos || videos.length === 0) return;

	videos.forEach((video) => {
		const href = video.getAttribute('data-href') || video.dataset.href;
		if (!href) return;

		video.addEventListener('click', function (e) {
			e.preventDefault();
			if (typeof lity !== 'undefined') {
				lity(href);
			} else {
				// fallback: open in new tab
				window.open(href, '_blank');
			}
		});
	});
});